"use client";
import SuggestedContentList from "./SuggestedContentList";
import SuggestedProductList from "./SuggestedProductList";
import TypeAheadSuggestionsList from "./TypeAheadSuggestionsList";
import { useTranslations } from "next-intl";

const SearchResultDropdown = ({
  productSuggestions,
  contentSuggestions,
  typeAheadSuggestions,
  onTypeAheadClick,
  foundProducts,
  onViewAllProductMatch,
  searchedTerm,
  categorySuggestions,
  showMigelConformity,
  memoizedPreviousSearch,
  memoizedVisitedCategories,
  memoizedVisitedProducts,
  memoizedVisitedContent,
}) => {
  const t = useTranslations();
  const hasTypeAheadSuggestions =
    Object.keys(typeAheadSuggestions)?.length > 0 || searchedTerm;
  const hasProductSuggestions = productSuggestions?.length > 0 || searchedTerm;
  const hasContentSuggestions = contentSuggestions?.length > 0 || searchedTerm;
  return (
    <div className="row">
      <div className="col-md-4 col-lg-3 mb-5 mb-lg-0 search-order-suggest">
        <TypeAheadSuggestionsList
          suggestions={
            hasTypeAheadSuggestions
              ? typeAheadSuggestions
              : memoizedPreviousSearch
          }
          categorySuggestions={
            hasTypeAheadSuggestions
              ? categorySuggestions
              : memoizedVisitedCategories
          }
          onSuggestionClick={onTypeAheadClick}
          headerText={t(
            hasTypeAheadSuggestions ? "suggestions" : "recently-searched",
          )}
          searchTerm={searchedTerm}
        />
      </div>

      <div className="col-md-8 col-lg-5 mb-5 mb-lg-0 search-order-products">
        <SuggestedProductList
          suggestions={
            hasProductSuggestions ? productSuggestions : memoizedVisitedProducts
          }
          header={t(
            hasProductSuggestions
              ? "suggested-products-header"
              : "visited-products-header",
          )}
          searchTerm={searchedTerm}
          showMigelConformity={showMigelConformity}
        />
        {!!foundProducts && (
          <button
            onClick={onViewAllProductMatch}
            type="button"
            className="no-button link d-block mt-3"
          >
            {t("view-all-product-matches", { foundProducts })}
          </button>
        )}
      </div>
      <div className="col-md-12 col-lg-4 search-order-content">
        <SuggestedContentList
          suggestions={
            hasContentSuggestions ? contentSuggestions : memoizedVisitedContent
          }
          header={t(
            hasContentSuggestions
              ? "content-suggestion-header"
              : "visited-content-header",
          )}
          searchTerm={searchedTerm}
        />
      </div>
    </div>
  );
};

export default SearchResultDropdown;
